export default class Form {

	constructor(selector){
		this.Data = {};
		this.selector = selector;

		document.querySelector(selector).querySelectorAll('[name]').forEach((element) => {
			var type = element.getAttribute('type'),
				name = element.getAttribute('name');

			if(type == 'checkbox'){
				this.Data[name] = document.querySelectorAll('[name="' + name + '"]:checked').length > 0 ? true : false;
			}else if(type == 'radio'){
				var radio = document.querySelectorAll('[name="' + name + '"]:checked');

				this.Data[name] = radio.length > 0 ? radio[0].value : null;
			}else if(type == 'file'){
				var files = document.querySelector('[name="' + name + '"]').files;

				if(files.length > 0){
					for(var i = 0; i < files.length; i++){
						this.Data[name + '[' + i + ']'] = files[i];
					}
				}else{
					this.Data[name] = null;
				}
			}else{
				this.Data[name] = element.value;
			}
		});
	}

	post(url, success){
		var Request = new XMLHttpRequest(),
			Data = new FormData();

		for(var key in this.Data){
			if(this.Data.hasOwnProperty(key)){
				Data.append(key, this.Data[key]);
			}
		}

		Data.append('nonce', php_vars.nonce);

		Request.onreadystatechange = (event) => {
			if(event.currentTarget.readyState == 4 && event.currentTarget.status == 200){
				success(event.currentTarget.response);
			}
		};

		Request.open('POST', url);
		Request.send(Data);
	}

}
